"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Disc: ()=>Disc
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../Image/index.cjs");
const external_Disc_variants_cjs_namespaceObject = require("./Disc.variants.cjs");
const Disc = ({ alt, content, contentType, emphasis, isVertical, hasMask, palette, size })=>{
    const { baseSlot } = (0, external_Disc_variants_cjs_namespaceObject.discVariants)({
        contentType,
        emphasis,
        hasMask,
        isVertical,
        palette,
        size
    });
    const renderContent = ()=>{
        switch(contentType){
            case 'icon':
                {
                    const getIconSize = (size)=>{
                        if ('2xs' === size) return '16';
                        if ('xs' === size) return '18';
                        if ('sm' === size) return '20';
                        if ('lg' === size) return '36';
                        return '24';
                    };
                    const iconSize = getIconSize(size);
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                        iconName: content,
                        size: iconSize
                    });
                }
            case 'imgFill':
                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                    src: content,
                    alt: alt ?? 'Disc Image',
                    width: "full",
                    height: "full",
                    objectFit: "cover"
                });
            case 'imgFit':
                {
                    const getImgFitSize = (size)=>{
                        if ('2xs' === size) return 4;
                        if ('xs' === size) return 5;
                        if ('sm' === size) return 6;
                        if ('lg' === size) return 12;
                        return 8;
                    };
                    const imgFitSize = getImgFitSize(size);
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                        src: content,
                        alt: alt ?? 'Disc Image',
                        width: imgFitSize,
                        height: imgFitSize,
                        objectFit: "contain"
                    });
                }
            case 'initials':
            default:
                {
                    const getInitials = (text)=>(text?.length === 2 ? text : text?.trim()?.slice(0, 2))?.toUpperCase();
                    return getInitials(content);
                }
        }
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: baseSlot(),
        children: renderContent()
    });
};
exports.Disc = __webpack_exports__.Disc;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Disc"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
